/**
 * Custom API utility to avoid "Response body already used" errors
 * Uses XMLHttpRequest instead of fetch to bypass cloning issues
 */

export const apiRequest = (url, options = {}) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const method = options.method || 'GET';
    
    xhr.open(method, url, true);
    
    // Set headers
    if (options.headers) {
      Object.keys(options.headers).forEach(key => {
        xhr.setRequestHeader(key, options.headers[key]);
      });
    }
    
    // Handle response
    xhr.onload = () => {
      try {
        const response = {
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status,
          statusText: xhr.statusText,
          data: xhr.responseText ? JSON.parse(xhr.responseText) : null
        };
        resolve(response);
      } catch (error) {
        reject(new Error('Failed to parse response'));
      }
    };
    
    // Handle errors
    xhr.onerror = () => {
      reject(new Error('Network request failed'));
    };
    
    xhr.ontimeout = () => {
      reject(new Error('Request timeout'));
    };
    
    // Send request
    if (options.body) {
      xhr.send(options.body);
    } else {
      xhr.send();
    }
  });
};
